// import React, { useState } from 'react';
import React from 'react';

//import TestesBasicos from './TestesBasicos';
import ListaAcademia from './ListaAcademia';

const App = () => {
  return (
    <>
      {/* <TestesBasicos /> */}

      <main>
        <ListaAcademia />
      </main>
    </>
  )
}

/*
function App() {
  return (
    ''
  );
}

*/
export default App;